import { addToCart } from '@nova/utils'

document.addEventListener('DOMContentLoaded', () => {
  const $forms = Array.from(document.querySelectorAll('.js-product-form') || [])
  const $sizeGuideBtns =
    document.querySelectorAll('.js-size-guide-button') || []
  const $sizeGuideDrawer = document.querySelector('.js-size-guide-drawer') || []

  function changeTimeZone(date, timeZone) {
    if (typeof date === 'string') {
      return new Date(
        new Date(date).toLocaleString('en-US', {
          timeZone,
        }),
      )
    }

    return new Date(
      date.toLocaleString('en-US', {
        timeZone,
      }),
    )
  }

  if ($forms.length) {
    for (const $form of $forms) {
      const $submitButton = $form.querySelector('[type="submit"]')
      const $quantityInput = document.querySelector(
        `nova-quantity-input[data-form-id=${$form.getAttribute('id')}]`,
      )
      $form.addEventListener('submit', (event) => {
        event.preventDefault()

        const displayDeliveryDates = $form.querySelector('#display_delivery_dates').value === 'true'
        const sellingPlan = $form.querySelector('[name="selling_plan"]')
        $submitButton.setAttribute('disabled', true)
        $submitButton.classList.add('loading')

        const formData = new FormData($form)
        const id = formData.get('id')
        const quantity = $quantityInput?.value || 1
        const properties = {}

        formData.get('id')

        $form.querySelectorAll('input[name^="properties["]').forEach(input => {
          if (input.name && input.value) {
            const propName = input.name.match(/properties\[(.*?)\]/)[1]
            properties[propName] = input.value
          }
        })

        if(displayDeliveryDates) {
          const localDate = new Date()
          const timeZone = 'America/New_York'
          const estTime = changeTimeZone(localDate, timeZone)
          const timeArr = estTime.toString().split(' ')
          const date = timeArr[0].toLowerCase()
          const hour = Number(timeArr[4].split(':')[0])
          const message_property = $form.querySelector('#display_delivery_dates').dataset.message
          const startDay = new Date()
          const endDay = new Date()
          if(date != 'mon') {
            startDay.setDate(startDay.getDate() + (((3 + 7 - startDay.getDay()) % 7) || 7))
          } else if(hour < 17) {
            startDay.setDate(startDay.getDate() + 2)
          } else {
            startDay.setDate(startDay.getDate() + (((3 + 7 - startDay.getDay()) % 7) || 7))
          }
          endDay.setDate(startDay.getDate() + 2)
          const message_dates = `${startDay.getMonth() + 1}/${startDay.getDate()}-${endDay.getMonth() + 1}/${endDay.getDate()}`
          properties[message_property] = message_dates
        }

        const params = { id, quantity, properties }
        if(sellingPlan) {
          params['selling_plan'] = sellingPlan.value
        }

        addToCart(params).then(() => {
          $submitButton.removeAttribute('disabled')
          $submitButton.classList.remove('loading')
        })
      })
    }

    document.addEventListener('nova:product:render-form', (event) => {
      const content = event.detail.html
      for (const $form of $forms) {
        if (!content) return
        $form.innerHTML = content.innerHTML
      }
    })
  }

  if ($sizeGuideDrawer) {
    for (const $button of $sizeGuideBtns) {
      $button.addEventListener('click', () => {
        if ($sizeGuideDrawer.hasAttribute('open')) {
          $sizeGuideDrawer.hide()
        } else {
          $sizeGuideDrawer.show()
        }
      })
    }
  }
})
